// extracted by mini-css-extract-plugin
module.exports =  {"root":"OOfbmF9_v4fQXQovZgJP","leg":"_Zip6PlyMFODXT8Gj2wu","legContent":"kb1taYZQSTFri02Zzzcx"};